<template>
	<b-list-group-item class="d-flex justify-content-between align-items-center">
		<span>
			<!-- slot lead -->
			<slot name="lead"></slot>

			<!-- title -->
			<span class="text-body">{{cq.title}}</span>
		</span>
		<!-- slot button -->
		<slot name="button"></slot>
	</b-list-group-item>
</template>
<script>
	export default {
		name: "closureQuestionListItem_component",

		data() {
			return {};
		},

		props: {
			cq: {
				type: Object,
				default: function() {
					return { id: null, title: null };
				}
			}
		}
	};
</script>
<style scoped>
	.ddMoveQIcon {
		cursor: move; /* fallback if grab cursor is unsupported */
		cursor: grab;
		cursor: -moz-grab;
		cursor: -webkit-grab;
	}
</style>
